import { Component } from '@angular/core';
import { LogoComponent } from '../../../../../shared/components/logo/logo.component';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [LogoComponent],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})
export class BannerComponent { }
